export default __webpack_public_path__ + "static/media/tick.82853286.svg";